import styled from '@emotion/styled';
import classNames from 'classnames/bind';
import { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface Props extends HTMLAttributes<HTMLElement>{
    fontWeight?: 'bold' | 'medium' | 'regular' | 'semibold';
    color?: string;
    align?: 'left' | 'right' | 'center';
    ellipsis?: boolean;
    size?: 'xs' | 's' | 'm' | 'lg' | 'xl' |'2xl' | '3xl' | '4xl';
    as?: 'p' | 'span' | 'div' | 'h1' |'h2' | 'h3' | 'h4' |'h5' | 'h6';
}

const cx = classNames.bind(styles);

function Text(props: Props) {
    const {
        children, fontWeight, className, color, align = 'left', ellipsis = false,
        as = 'p',
        size = 'm', ...rest
    } = props;
    const { i18n: { language } } = useTranslation();
    const Component = styled(as)`
      color: ${color};
  `;
    return (
        <Component
            lang={language}
            className={cx(
                'text',
                `text-${fontWeight}`,
                `align-${align}`,
                `size-${size}`,
                { ellipsis },
                className,
            )}
            {...rest}>
            {children}
        </Component>
    );
}

export default Text;
